const fireCustomerCloseEvent = () => {
    const event = document.createEvent('Event') as any;
    event.initEvent('customer_close', true, true);
    document.body.dispatchEvent(event);
}

export default fireCustomerCloseEvent;
